import { EntityType } from '../types/cache-types';

/**
 * Factory per generare query keys consistenti in tutto l'applicativo
 * Facilita l'invalidazione e la gestione della cache
 */
export const createQueryKeys = <T extends string>(entity: EntityType) => {
  return {
    all: [entity] as const,
    lists: () => [...createQueryKeys(entity).all, 'list'] as const,
    list: (params: Record<string, unknown> = {}) => 
      [...createQueryKeys(entity).lists(), params] as const,
    details: () => [...createQueryKeys(entity).all, 'detail'] as const,
    detail: (id: string | number) => 
      [...createQueryKeys(entity).details(), id] as const,
  };
};

// Query keys predefinite per le entità comuni
export const queryKeys = {
  products: createQueryKeys('products'),
  users: createQueryKeys('users'),
  orders: createQueryKeys('orders'),
  customers: createQueryKeys('customers'),
  categories: createQueryKeys('categories'),
  settings: createQueryKeys('settings'),
  requests: createQueryKeys('requests'),
  tasks: createQueryKeys('tasks'),
};